<h1 mat-dialog-title>{{ data.modalTitle }}</h1>
<mat-dialog-content>
  <div class="row mb-1">
    <table class="table table-borderless">
      <tr *ngFor="let existingNote of data.existingNotes">
        <td>
          <div class="note-preview-box">
            <div class="created-at" title="{{ existingNote?.createdAt }}">
              {{ existingNote?.createdAt | date:'medium' }} - {{ existingNote?.createdBy.firstName }} {{
              existingNote?.createdBy.lastName }}</div>
            <div class="text">{{ existingNote?.text }}</div>
          </div>
        </td>
        <td>
          <mat-icon fontSet="fal" fontIcon="fa-edit" class="icon-action" matTooltip="Modifica"
            (click)="onEdit(existingNote?.text, existingNote._id)">
          </mat-icon>
          <mat-icon fontSet="fal" fontIcon="fa-trash" class="icon-action" matTooltip="Elimina"
            (click)="onDelete(existingNote._id)">
          </mat-icon>
        </td>
      </tr> <!-- /.col -->
    </table>
  </div> <!-- ./row -->
</mat-dialog-content> <!-- mat-dialog-content -->
<div mat-dialog-actions>
  <div class="row w-100">
    <div class="col-12 text-left">
      <a mat-button (click)="onClose()" mat-raised-button mat-default>{{ 'common.cta.close' | translate }}</a>
    </div> <!-- /.col -->
  </div> <!-- /.row -->
</div>